import { ResultType } from "@careevolution/mydatahelps-cel";
import { isValid, parse, parseISO } from "date-fns";

export function convertAnswerToType(answer: string[], targetType: ResultType): any {
  try {
    if (targetType.startsWith("List<")) {
      const primitiveType = targetType.substring("List<".length, targetType.length - 1) as ResultType;
      return answer.map(a => convertSingleAnswerToType(a, primitiveType));
    }

    return convertSingleAnswerToType(answer?.[0] ?? null, targetType);
  } catch {
    return null;
  }
}

function convertSingleAnswerToType(answer: string | null, answerType: ResultType): string | boolean | number | null {
  if (answer == null) {
    return null;
  }

  if (answerType === "Text") {
    return answer;
  }

  if (answerType === "Boolean") {
    return answer.toLowerCase() === "true";
  }

  if (answerType === "Integer") {
    const n = parseInt(answer, 10);
    return Number.isNaN(n) ? null : n;
  }

  if (answerType === "Decimal") {
    const n = parseFloat(answer);
    return Number.isNaN(n) ? null : n;
  }

  if (answerType === "Date" || answerType === "Timestamp") {
    const dt = parseISO(answer);
    return isValid(dt) ? answer : null;
  }

  if (answerType === "TimeOfDay") {
    const dt = parse(answer, "hh:mm a", new Date());
    return isValid(dt) ? answer : null;
  }

  return null;
}